import {
  InputLabel,
  FormControl,
  FormHelperText,
  Select,
  FormControlProps,
  InputLabelProps,
} from '@material-ui/core';
import React from 'react';
import type { WrappedFieldProps } from 'redux-form';
import type { SelectProps } from '@material-ui/core/Select';

type Props = {
  fullWidth: boolean;
  required: boolean;
  label: string;
  helperText: string;
  defaultValue: string;
  formControlProps: FormControlProps;
  labelProps: InputLabelProps;
} & WrappedFieldProps &
  SelectProps;

const FormSelect = ({
  fullWidth,
  required,
  label,
  helperText,
  input,
  meta,
  formControlProps,
  labelProps,
  defaultValue,
  ...rest
}: Props): JSX.Element => {
  const isWithError = !!(meta.touched && meta.error);

  return (
    <FormControl
      style={{ width: '100%' }}
      required={required}
      fullWidth={fullWidth}
      error={isWithError}
      {...formControlProps}
    >
      {label ? (
        <InputLabel htmlFor={input.name} {...labelProps}>
          {label}
        </InputLabel>
      ) : null}
      <Select
        inputProps={{
          id: input.name,
        }}
        required={required}
        {...rest}
        {...input}
      />
      {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
      {isWithError ? <FormHelperText>{meta.error}</FormHelperText> : null}
    </FormControl>
  );
};

export default FormSelect;
